module.exports = __webpack_public_path__ + "img/minor.66ab8c38.png";